module.exports = __webpack_public_path__ + "img/cocina.ba505ef3.svg";